<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="course.course_name + ' - ' + student_name + ' [Employee Training Course] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses`">
                            <i class="fa fa-graduation-cap"></i> Training Courses
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses/view/${course.training_course_id}`">
                             {{ course.course_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <span v-if="course.completed_at">{{ course.completed_at | moment("MM/DD/YYYY") }} by</span> {{ student_name }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-9 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Training Course</strong>
                            <div class="pull-right" v-if="this.$root.hasPermission(['training_courses.manage'])">
                                <router-link :to="`/training-courses/employee/${course.training_course_id}/${course.id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <button type="button" v-on:click="postCreateCertificate()" class="btn btn-sm btn-light" :disabled="creating_cert" v-if="course.certificate_template_id && course.completed_at">
                                    <i class="fa fa-files-o"></i> Certificate <i class="fa fa-spin fa-spinner" v-if="creating_cert"></i>
                                </button>
                                <b-dropdown right text="Distribute" variant="light" size="sm">
                                    <b-dropdown-item :to="`/training-courses/distribute/email?emp_course_id=${course.id}`"><i class="fa fa-envelope"></i> Email</b-dropdown-item>
                                    <b-dropdown-item :to="`/training-courses/distribute/text?emp_course_id=${course.id}`"><i class="fa fa-comment"></i> Text</b-dropdown-item>
                                </b-dropdown>
                                <router-link :to="`/training-courses/employee/${course.id}/delete`" class="btn btn-sm btn-light">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row mb-2">
                                        <div class="col-md-4 text-md-right text-muted">Course:</div>
                                        <div class="col-md-8">
                                            <router-link :to="`/training-courses/view/${course.training_course_id}`">{{ course.course_name }}</router-link>
                                        </div>
                                    </div>
                                    <template v-if="course.employee_id">
                                        <div class="row mb-2">
                                            <div class="col-md-4 text-md-right text-muted">Employee:</div>
                                            <div class="col-md-8">
                                                <router-link :to="`/employees/view/${course.employee_id}`">{{ course.FirstName }} {{ course.LastName }}</router-link>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4 text-md-right text-muted">Employee Phone#:</div>
                                            <div class="col-md-8">
                                                {{ course.Phone }}
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4 text-md-right text-muted">Employee Email:</div>
                                            <div class="col-md-8">
                                                <a :href="`mailto:${course.email}`" v-if="course.email">{{ course.email }}</a>
                                            </div>
                                        </div>
                                        <div class="row mb-2" v-if="course.IsActive !== null">
                                            <div class="col-md-4 text-md-right text-muted">Employee Status:</div>
                                            <div class="col-md-8">
                                                <label class="badge badge-success" v-if="course.IsActive === 1">Active</label>
                                                <label class="badge badge-warning" v-else-if="course.IsActive === 0">Inactive</label>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="row mb-2" v-else>
                                        <div class="col-md-4 text-md-right text-muted">Completed By:</div>
                                        <div class="col-md-8">
                                            {{ course.person_name }} - {{ course.person_company }}
                                        </div>
                                    </div>

                                    <div class="row mb-2">
                                        <div class="col-md-4 text-md-right text-muted">Notes:</div>
                                        <div class="col-md-8">
                                            {{ course.notes }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row mb-2" v-if="course.jobsite_id">
                                        <div class="col-md-4 text-md-right text-muted">Jobsite:</div>
                                        <div class="col-md-8">
                                            <router-link :to="`/jobsites/view/${course.jobsite_id}`">{{ course.JobsiteNumber }} - {{ course.JobsiteName }}</router-link>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-4 text-md-right text-muted">Date Completed:</div>
                                        <div class="col-md-8">
                                            {{ course.completed_at | moment("MM/DD/YYYY") }}
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-4 text-md-right text-muted">Date Expires:</div>
                                        <div class="col-md-8">
                                            {{ course.expires_at | moment("MM/DD/YYYY") }}
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-4 text-md-right text-muted">Last Text Distribution:</div>
                                        <div class="col-md-8">
                                            <span v-if="course.last_texted_at">{{ course.last_texted_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-4 text-md-right text-muted">Last Email Distribution:</div>
                                        <div class="col-md-8">
                                            <span v-if="course.last_emailed_at">{{ course.last_emailed_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3"  v-if="course.course_key && course.enable_public_access == 1">
                                <div class="col-md-2 text-md-right text-muted">Public URL:</div>
                                <div class="col-md-10">
                                    <a :href="`/training-courses/key/${course.course_key}?emp_course_id=${course.id}`" target="_blank">
                                        {{ $root.appUrl }}/training-courses/key/{{ course.course_key }}?emp_course_id={{ course.id }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4 mb-4">
                        <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                            <b-nav-item :active="curTab === 'comments'" @click="curTab = 'comments'">
                                <i class="fa fa-comments"></i> Comments ({{ totalComments }})
                            </b-nav-item>
                            <b-nav-item :active="curTab === 'files'" @click="curTab = 'files'">
                                <i class="fa fa-files-o"></i> Files ({{ files.length }})
                            </b-nav-item>
                        </ul>

                        <div class="mb-2 mb-lg-0 d-lg-none d-block">
                            <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
                                <b-dropdown-item :active="curTab === 'comments'" @click="curTab = 'comments'">
                                    <i class="fa fa-comments"></i> Comments ({{ totalComments }})
                                </b-dropdown-item>
                                <b-dropdown-item :active="curTab === 'files'" @click="curTab = 'files'">
                                    <i class="fa fa-files-o"></i> Files ({{ files.length }})
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>

                        <div class="mt-4">
                            <div class="card" v-show="curTab === 'comments'">
                                <div class="card-body">
                                    <comment-list
                                        :allowNewComments="this.$root.hasPermission('training_courses.manage')"
                                        ref="commentList"
                                        :assetId="course.id"
                                        assetType="EmployeeTrainingCourse"
                                        @commentListCount="(total) => { this.totalComments = total; }" />
                                </div>
                            </div>
                            <div class="card" v-show="curTab === 'files'">
                                <div class="card-body">
                                    <file-list :files="files" :displayType="'table'" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-xl-4 col-lg-12">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                creating_cert: false,
                curTab: 'comments',
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                course: {},
                files: [],
                totalComments: null,

                settingsTabs: {
                    comments: 'Comments',
                    files: 'Files',
                },
            }
        },

        computed: {
            student_name(){
                //Check for employee
                if(this.course.employee_id)
                {
                    return this.course.FirstName + ' ' + this.course.LastName;
                }

                return this.course.person_name + ' - ' + this.course.person_company;
            },

            tabButtonTitle(){
                //Send it
                var icon = '<i class="fa fa-bars"></i> ';
                var count = '';

                //Switch
                switch(this.curTab)
                {
                    case 'comments':
                        //Append Count
                        icon = '<i class="fa fa-comments"></i>';
                        count = ' ('+this.totalComments+')';
                        break;

                    case 'files':
                        //Append Count
                        icon = '<i class="fa fa-files-o"></i>';
                        count = ' ('+this.files.length+')';
                        break;
                }

                //Send it
                return icon + ' ' + this.settingsTabs[this.curTab] + count;
            },
        },

        methods: {

            getEmpTrainingCourse(){
                //Get the data
                this.$http
                    .get('/training-courses/employee/' + this.id + '/view')
                    .then(response => {
                        //Set all the data
                        this.course = response.data.course;
                        this.files = response.data.files;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            postCreateCertificate(){
                //Basic Confirm for Now
                if(!confirm('Are you sure you want to generate a Completed Certificate for this course? This does not delete any old certificates.'))
                {
                    return;
                }

                //Setup
                this.creating_cert = true;

                //Send it
                this.$http.post(`/training-courses/employee/${this.course.id}/certificate`)
                    .then(response => {
                        //Set all the data
                        this.files.push(response.data);

                        //Alert
                        this.$toastr.success('Certificate Created. Check the "Files" section to view the new file.');
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.creating_cert = false;
                    });
            },

        },

        mounted() {
            //Get the Training Course
            this.getEmpTrainingCourse();
        }
    }
</script>
